import { render, staticRenderFns } from "./ItemCardFrameAssemblyTypeSelection.vue?vue&type=template&id=88cdf0bc&scoped=true"
import script from "./ItemCardFrameAssemblyTypeSelection.vue?vue&type=script&lang=ts"
export * from "./ItemCardFrameAssemblyTypeSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cdf0bc",
  null
  
)

export default component.exports